/* unplugin-vue-components disabled */import script from "./orderInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./orderInfo.vue?vue&type=script&lang=ts&setup=true"

import "./orderInfo.vue?vue&type=style&index=0&id=f6287a32&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6287a32"]])

export default __exports__